import { makeLocalId as makeSeededLocalId } from "~/shared/lib/local-id";

/** Локальный ID для optimistic pending-загрузки (до presign). */
export const makeUploadLocalId = (file: File): string => makeSeededLocalId(file.name, String(file.size));

/**
 * Нужно ли blob-превью для данного MIME. Image и video показываем превью
 * (для video — первый кадр через <video src=...#t=0.1 preload=metadata>).
 * Звуку кадр не нужен, но ссылка нужна: без неё плитка в очереди остаётся
 * немой иконкой, и убедиться, что прикреплена та самая дорожка, до отправки
 * нечем — а звук, взятый из библиотеки, при этом играет.
 */
export const needsPreview = (mimeType: string): boolean =>
    mimeType.startsWith("image/") || mimeType.startsWith("video/") || mimeType.startsWith("audio/");
